<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid navgator-container">  
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">          
        <ul >
          <li class="text-navgator-mob">
            <a href="/admin" class="nav-link">
              <i class="bi bi-house-door icon-navgator-mob"></i>
              Desk / {{ titulo }}
            </a>
          </li>
        </ul>
      
      </div>  
 
    </div>
  </nav>
</template>

<script>
export default {
  props: ["barraTitulo", "titulo"],
};
</script>
